'use strict';

module.exports = require('./lib/ReactDOMServer');



/*****************
 ** WEBPACK FOOTER
 ** ../~/react-dom/server.js
 ** module id = 1121
 ** module chunks = 3
 **/